export default __webpack_public_path__ + "static/media/rocket_anim_77.277b27cf.png";